import PropTypes from 'prop-types';
//
import ThemeContrast from './ThemeContrast';
import ThemeRtlLayout from './ThemeRtlLayout';
import ThemeColorPresets from './ThemeColorPresets';
import ThemeLocalization from './ThemeLocalization';

// ----------------------------------------------------------------------

ThemeSettings.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function ThemeSettings({ children }) {
  return (
      <ThemeContrast>
        <ThemeLocalization>
          <ThemeRtlLayout>
            {children}
          </ThemeRtlLayout>
        </ThemeLocalization>
      </ThemeContrast>
  );
}
